<template>
  <div>
    <div class="d-flex gap-2 mb-6">
      <tm-skeleton
        height="36px"
        width="14%"
      />
      <tm-skeleton
        height="36px"
        width="22%"
      />
      <tm-skeleton
        height="36px"
        width="10%"
      />
    </div>
    <tm-skeleton-details-table-redesign preset="column-reverse">
      <tm-skeleton-details-table-sms-preview />
    </tm-skeleton-details-table-redesign>
  </div>
</template>

<script lang="ts" setup>
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import TmSkeletonDetailsTableRedesign from '@/components/shared/skeletons/TmSkeletonDetailsTableRedesign.vue'
import TmSkeletonDetailsTableSmsPreview from '@/components/shared/skeletons/TmSkeletonDetailsTableSmsPreview.vue'
</script>
